<template>
    <div v-if="!party && !responded">
        <p class="mb-5">You will have received a five digit code with your wedding invitation. Enter it below to fill
            out your response.</p>

        <div class="col-lg-3 col-sm-6 ml-auto mr-auto">
            <div role="form">

                <div class="form-group">
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fa fa-code"></i></span>
                        </div>
                        <input type="text" class="form-control" v-bind:class="{ 'is-invalid': invalidCode }"
                               v-model="code"/>

                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary btn-primary" type="button" @click="getParty()">
                                Go
                            </button>
                        </div>
                    </div>

                    <div class="invalid-feedback" v-bind:class="{ 'd-block': invalidCode }">The code you entered is not
                        valid.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-else-if="party && !party.responded">
        <h4>{{party.name}}</h4>
        <p>Indicate whether or not each guest in your party will be attending. If you have additional seats that you
            don't need, just click not attending.</p>
        <p class="mb-5">Please provide an email address for at least one guest so that we can provide your party with
            updates.</p>

        <div class="col-sm-10 m-auto">
            <div class="form-row mb-3" v-for="(person, index) in party.people">
                <div class="col-sm-12 col-md-3 form-group m-0">
                    <label>Guest</label>
                    <input type="text"
                           v-bind:class="{'form-control': person.additional,'form-control-plaintext': !person.additional,'text-white': !person.additional,'is-invalid': errors['people.'+index+'.name']}"
                           v-bind:readonly="!person.additional" v-model="person.name" placeholder="Enter guest name...">
                    <div class="invalid-feedback" v-if="errors['people.'+index+'.name']">{{
                        errors['people.'+index+'.name'][0] }}
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 form-group m-0">
                    <label>Email</label>
                    <input type="email" v-model="person.email" class="form-control"
                           v-bind:class="{'is-invalid': errors['people.'+index+'.email']}"
                           placeholder="Enter guest email...">
                    <div class="invalid-feedback" v-if="errors['people.'+index+'.email']">{{
                        errors['people.'+index+'.email'][0] }}
                    </div>
                </div>

                <div class="col-sm-12 col-md-3 m-0">
                    <label></label>
                    <div class="col form-check form-check-inline">
                        <input type="radio" class="form-check-input" v-bind:name="person.id" v-bind:value="true"
                               v-bind:class="{'is-invalid': errors['people.'+index+'.rsvp']}"
                               v-model="person.rsvp">
                        <label class="form-check-label">Attending</label>
                    </div>

                    <div class="col form-check form-check-inline">
                        <input type="radio" class="form-check-input" v-bind:name="person.id" v-bind:value="false"
                               v-bind:class="{'is-invalid': errors['people.'+index+'.rsvp']}"
                               v-model="person.rsvp">
                        <label class="form-check-label">Not attending</label>
                    </div>
                    <div class="invalid-feedback" v-bind:class="{'d-block': errors['people.'+index+'.rsvp']}"
                         v-if="errors['people.'+index+'.rsvp']">{{ errors['people.'+index+'.rsvp'][0] }}
                    </div>
                </div>
            </div>

            <br/>

            <button class="btn btn-outline-secondary btn-primary" type="button" @click="rsvp(party, additional)">RSVP
            </button>
        </div>
    </div>

    <div v-else-if="party && party.responded && this.attending.length > 0 && !party.menu">
        <h4>{{party.name}}</h4>
        <p>We look forward to seeing you! Our menu for the evening is as follows:</p>
        <p>
            <strong>Appetizer:</strong>
            <br/>Signature Garden Balsamic
            <small><em>Mixed Baby Greens, Radicchio Red Leaf lettuce, curly Endive &amp; Romaine lettuce, in a home made
                Honey Balsamic Vinaigrette.</em>
            </small>
        </p>
        <p>
            <strong>Choice of Entree:</strong>
            <span v-for="entree in entrees">
            <br/>{{ entree.name }}
                <small v-show="entree.description"><em>{{ entree.description }}</em></small>
        </span>
            <br/><br/>All entrees served with: Roasted Red Potatoes, Red Peppers, and Asparagus.
        </p>
        <p>
            <strong>Dessert:</strong>
            <br/>Creme Brûlée / Crepes
        </p>
        <p class="mb-5">Please select an entree for each guest. Children under 12 will be served Chicken Fingers &amp;
            Fries.</p>

        <div class="col-sm-10 m-auto">
            <div class="form-row mb-3" v-for="(person, index) in attending">
                <div class="col-sm-12 col-md-3 form-group m-0">
                    <label>Guest</label>
                    <input type="text" class="form-control-plaintext text-white" readonly v-model="person.name"
                           placeholder="Enter guest name...">
                </div>

                <div class="col-sm-12 col-md-3 m-0">
                    <label>Entree</label>
                    <div class="col form-check form-check-inline" v-for="entree in entrees">
                        <input type="radio" class="form-check-input" v-bind:name="person.id" v-bind:value="entree.id"
                               v-bind:class="{'is-invalid': errors['people.'+index+'.entree_id']}"
                               v-model="person.entree_id">
                        <label class="form-check-label">{{ entree.name }}</label>
                    </div>

                    <div class="invalid-feedback" v-bind:class="{'d-block': errors['people.'+index+'.entree_id']}"
                         v-if="errors['people.'+index+'.entree_id']">{{ errors['people.'+index+'.entree_id'][0] }}
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 form-group m-0">
                    <label>Special Instructions</label>
                    <input type="email" v-model="person.diet" class="form-control"
                           v-bind:class="{'is-invalid': errors['people.'+index+'.diet']}"
                           placeholder="Enter any food allergies, dietary restrictions, etc...">
                    <div class="invalid-feedback" v-if="errors['people.'+index+'.diet']">{{
                        errors['people.'+index+'.email'][0] }}
                    </div>
                </div>
            </div>

            <br/>

            <button class="btn btn-outline-secondary btn-primary" type="button" @click="menu()">Save
            </button>
        </div>
    </div>

    <div v-else-if="party && party.responded && (this.attending.length === 0 || party.menu)">
        <h4>{{party.name}}</h4>
        <p>We have already received your response!</p>

        <p class="m-0" v-for="(person, index) in party.people" v-if="person.name">
            {{ person.name }} <span v-if="person.email">(<a :href="'mailto:'+person.email">{{person.email}}</a>)</span>
            is <strong v-if="!person.rsvp">NOT</strong> attending.
        </p>

        <p class="mt-2">If you have an issue with your RSVP, please contact us.</p>
    </div>

    <div v-else-if="responded">
        <p>Thank you for your response, {{ partyName }}!</p>
    </div>
</template>

<script>
    export default {
        /*
         * The component's data.
         */
        data()
        {
            return {
                code: null,
                invalidCode: false,
                party: null,
                additional: [],
                responded: false,
                partyName: null,
                entrees: [],
                attending: [],
                errors: []
            };
        },

        /**
         * Prepare the component (Vue 2.x).
         */
        mounted()
        {
            this.getEntrees();
        },

        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            /*prepareComponent() {
                this.getTokens();
            },*/

            /**
             * Get the party from a RSVP code.
             */
            getParty()
            {
                this.invalidCode = false;

                axios.get('/api/rsvp/' + this.code)
                    .then(response => {
                        this.party = response.data;

                        if (this.party.responded) {
                            this.attending = _.filter(this.party.people, function (person) {
                                return (person.rsvp && !person.underage);
                            });

                            console.log(this.attending);
                        }
                    })
                    .catch(response => {
                        this.invalidCode = true;
                    });
            },

            /**
             * Update the RSVP for each party member.
             */
            rsvp(party, additional)
            {
                axios.post('/api/rsvp/' + party.id, {
                    people: party.people, additional: additional
                })
                    .then(response => {
                        this.party.responded = true;
                        this.partyName = this.party.name;

                        this.attending = _.filter(this.party.people, function (person) {
                            return (person.rsvp && !person.underage);
                        });

                        if (this.attending.length === 0) {
                            this.code = null;
                            this.party = null;
                            this.responded = true;
                        }
                    })
                    .catch(response => {
                        if (response.response.status === 422) {
                            this.errors = response.response.data.errors;
                        }
                    });
            },

            /**
             * Get entrees.
             */
            getEntrees()
            {
                axios.get('/api/entrees')
                    .then(response => {
                        this.entrees = response.data;
                    });
            },

            /**
             * Update the entree choice for each party member.
             */
            menu()
            {
                axios.post('/api/menu/' + this.party.id, {
                    people: this.attending
                })
                    .then(response => {
                        this.code = null;
                        this.partyName = this.party.name;
                        this.party = null;
                        this.responded = true;
                    })
                    .catch(response => {
                        if (response.response.status === 422) {
                            this.errors = response.response.data.errors;
                        }
                    });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/RSVP.vue